// A revision prevents late requests from restoring data from a revoked view.
export const financeContext = { scope: 'self', goals: 'self', revision: 0 };
export function setFinanceContext(scope = 'self', goals = 'self') {
    financeContext.scope = scope;
    financeContext.goals = goals;
    financeContext.revision += 1;
}
